<template>
    <BannerComponent title="Nosotros" show="true"
        paragraph="Aquí encontraras toda la información relevante sobre la Marca Lr Pro Marketing" colorTitle="black"
        colorParagraph="gray" backgroundColor="white" aligmentContent="center" paddingY="20px" />
    
</template>

<script>
import BannerComponent from '../components/Banner-component.vue';
export default {
    name: 'AboutPage',
    components: {
        BannerComponent
    }
}
</script>
<style lang="scss" scoped>
</style>
